module.exports = __webpack_public_path__ + "static/media/intl_101.77b15472.ico";